const Predefined_Remarks = [
  {
    comment: "As per EMR Inspector's request",
    modes: [],
  },
  {
    comment: 'High demand/lack of units (Deficit) - Mail from the terminal/depot',
    modes: ['02', '43', '45', '03', '04', '05'],
  },
  {
    comment: "Customer's cargo was at risk of damage",
    modes: ['40', '41', '46'],
  },
  {
    comment: 'Incorrect/insufficient repair done previously',
    modes: ['02', '43', '45', '03', '04', '05'],
  },
  {
    comment: 'Handling/Terminal damages',
    modes: [],
  },
  {
    comment: 'Manual Monitoring',
    modes: ['40', '41', '46'],
  },
  {
    comment: 'Cold Treatment',
    modes: ['43'],
  },
  {
    comment: 'Pharma PTI / Super Freezer PTI / CA PTI',
    modes: ['43', '45'],
  },
  {
    comment: 'PQC – Approved after Regional confirmation',
    modes: ['03'],
  },
  {
    comment: 'Others - Need to be reviewed',
    modes: [],
  },
];

export default Predefined_Remarks;
